import React from "react";
import './Modal.css';

// function scale(){
//   //document.getElementById("imagen-modal").style.transform = "scale(2)";
//   console.log("deded")
// }

export default function Modal({ handleClose, show, image }) {
  const showHideClassName = show ? "modal display-block" : "modal display-none";



  return (

    <div className={showHideClassName}>
      <section className="modal-main">
        {/* {children} */}
        <div>

        </div>
        <img className='contorno'
          id="imagen-modal" src={process.env.PUBLIC_URL + image} alt="No se pudo cargar la imagen">
        </img>

      </section>
      <div className="row m-3">
        <div className="col-6">
          <a href={process.env.PUBLIC_URL + image} target="_blank">Ver en pantalla completa</a>

        </div>
        <div className="col-6 d-flex justify-content-end">
          <i class="fas fa-times" onClick={handleClose}></i>
        </div>
      </div>
    </div>
  );
};